import AboutMe from "../AboutMe/AboutMe";
import Blog from "../Blog/Blog";
import ContactMe from "../ContactMe/ContactMe";
import HeroSection from "../HeroSection/HeroSection";
import MySkill from "../MySkill/MySkill";
import NavBar from "../Navbar/NavBar";
import Portfolio from "../Portfolio/Portfolio";

export default function Home() {
  return (
    <>
      <NavBar />
      <HeroSection />
      <AboutMe />
      <MySkill />
      <Portfolio />
      <Blog />
      <ContactMe />
    </>
  );
}
